import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound-container">
      <h1 className="notfound-code">404</h1>
      <h2 className="notfound-message">Sorry, we couldn't find this page.</h2>
      <p className="notfound-subtext">
      No worries! You can start fresh from the previous page
      </p>
      <button className="notfound-button" onClick={() => navigate(-1)}>
        Back
      </button>
    </div>
  );
};

export default NotFound;
